import {
  ICreateWarehouseRequest,
  IDeleteByIdRequest,
  IGetByIdRequest,
  IUpdateWarehouseRequest,
  IGetAllWarehouseResponse,
  IGetWarehouseByIdResponse,
  ICreateWarehouseResponse,
  IUpdateWarehouseResponse,
  IDeleteWarehouseResponse,
} from "model";
import { IGetAllWarehousesRequest } from "model/Warehouse";
import { PREFIX } from "utils/Const";
import { BaseApiService } from "./BaseApiService";

const getUrl = (url: string) => {
  return `${PREFIX.masterData}/${url}`;
};

const URL_GET_ALL_WAREHOUSES = getUrl("get-all-warehouses");
const URL_GET_WAREHOUSE_BY_ID = getUrl("get-warehouse-by-id");
const URL_CREATE_WAREHOUSE = getUrl("create-warehouse");
const URL_UPDATE_WAREHOUSE = getUrl("update-warehouse");
const URL_DELETE_WAREHOUSE = getUrl("delete-warehouse");

class WarehouseApiService extends BaseApiService {
  public getAllWarehouses = (request: IGetAllWarehousesRequest) =>
    this.get<IGetAllWarehouseResponse>(URL_GET_ALL_WAREHOUSES, {
      params: request,
    });
  public getWarehouseById = (request: IGetByIdRequest) =>
    this.get<IGetWarehouseByIdResponse>(URL_GET_WAREHOUSE_BY_ID, {
      params: request,
    });
  public createWarehouse = (request: ICreateWarehouseRequest) =>
    this.post<ICreateWarehouseRequest, ICreateWarehouseResponse>(
      URL_CREATE_WAREHOUSE,
      request
    );
  public updateWarehouse = (request: IUpdateWarehouseRequest) =>
    this.put<IUpdateWarehouseRequest, IUpdateWarehouseResponse>(
      URL_UPDATE_WAREHOUSE,
      request
    );
  public deleteWarehouse = (request: IDeleteByIdRequest) =>
    this.delete<IDeleteWarehouseResponse>(URL_DELETE_WAREHOUSE, {
      params: request,
    });
}

export default new WarehouseApiService();
